import { createApp } from 'vue';
import previewApp from './previewApp.vue';
import { get } from '@assets/js/imaios-global/imaios-global';

const routeLanguage = [
  'en',
  'cn'
];
const routeList = routeLanguage.map((lang) =>
  window.imaiosRouting
    .getFosJsRoutingUrlWithSiteaccess(`structure-view-full-${lang}`, {
      application: get('application')
    })
    .split('/')
    .pop()
);

export default {
  appList: [],

  removeStructurePreviewApp() {
    this.appList.forEach(({ app, containerEl, oldElement }) => {
      app.unmount();

      // Restore the DOM without application vue
      if (containerEl.parentNode) {
        containerEl.parentNode.replaceChild(oldElement, containerEl);
      }
    });

    this.appList = [];
  },

  async createStructurePreviewApp() {
    this.removeStructurePreviewApp();
    // get container by id
    const staticContainers = [
      document.getElementById('structure-definitionText'),
      document.getElementById('structure-tooltip')
    ].filter(Boolean);

    // get container with data attribute data-container-link="true"
    const dynamicContainers = Array.from(
      document.querySelectorAll('[data-container-structure-link="true"]')
    );

    //fusion and remove duplicate
    const definitionContainers = Array.from(new Set([ ...staticContainers, ...dynamicContainers ]));

    // get links
    const definitionContainerLinks = definitionContainers
      .flatMap(container => Array.from(container.getElementsByTagName('a')));

    this.appList = Array.from(definitionContainerLinks)
      .filter((link) =>
        routeList.some((pathSegment) => link.href.includes(pathSegment))
      )
      .map((structureLink) => {
        // To safely extract information from the original structureLink before the previewApp component
        // mounts and potentially modifies it, we create a deep copy. This ensures that the information
        // we need is preserved on the copied node, while the original structureLink can be updated by the previewApp
        // without losing that data.
        const deepCopyStructureLink = structureLink.cloneNode(true);
        const containerEl = document.createElement("span");
        const app = createApp(previewApp, {
          structureLink: structureLink,
        });

        app.mount(containerEl);

        structureLink.replaceWith(containerEl);

        return { app, containerEl, oldElement: deepCopyStructureLink };
      });
  },
};
